import { useCallback } from 'react'
import { usePolling } from './usePolling'
import type { RfqSellerView, RfqBuyerView, ProvisioningView } from '../api/schema'
import { getBuyerProvisionings, getBuyerRFQs, getSellerProvisionings, getSellerRFQs } from '../api/api-client'

/** Polls the seller's open auctions from the Flask backend every 5s. */
export function useOpenRFQs() {
  const fetcher = useCallback(() => getSellerRFQs(), [])
  const { data: rows, error, loading, refresh } = usePolling(fetcher)
  return { rows: rows ?? [] as RfqSellerView[], error, loading, refresh }
}

export function useSellerProvisionings() {
  const fetcher = useCallback(() => getSellerProvisionings(), [])
  const { data: rows, error, loading, refresh } = usePolling(fetcher)
  return { provisionings: rows ?? [] as ProvisioningView[], error, loading, refresh }
}

export function useBuyerProvisionings() {
  const fetcher = useCallback(() => getBuyerProvisionings(), [])
  const { data: rows, error, loading, refresh } = usePolling(fetcher)
  return { provisionings: rows ?? [] as ProvisioningView[], error, loading, refresh }
}

export function useOpenBuyerRFQs() {
  const fetcher = useCallback(() => getBuyerRFQs(), [])
  const { data: rows, error, loading, refresh } = usePolling(fetcher)
  return { rows: rows ?? [] as RfqBuyerView[], error, loading, refresh }
}

/** @deprecated Use useOpenRFQs */
export const useQuoteRequests = useOpenRFQs  // alias kept for backward compat
